export default __webpack_public_path__ + "static/media/Fraunhofer-DarkModeSpheres.887c7bc2.jpg";